import { useTranslation } from "react-i18next";
import { UserMenu } from "@digitalisation/enlixy-comp";
import { useAuth } from "../auth/useAuth";
import { setDemoModeAndReload } from "../services/demoMode";
import { useSettingsStore } from "../store/SettingsStore";
import { getOrgAlias } from "../utils/tokenUtils";
import { useUserMenuUi } from "./userMenuUiStore";

/**
 * The avatar at the right of the header (UserMenu of @digitalisation/enlixy-comp):
 * name and e-mail, light / dark / system, the user's Keycloak account, the demo
 * dataset switch (the former settings page) and sign-out; the organization and
 * version at the bottom.
 */
export function CockpitUserMenu() {
  const { t } = useTranslation();
  const { user, token, logout, accountManagement } = useAuth();
  const demoMode = useSettingsStore((s) => s.demoMode);
  const autoDemoMode = useSettingsStore((s) => s.autoDemoMode);
  const open = useUserMenuUi((s) => s.open);
  const setOpen = useUserMenuUi((s) => s.setOpen);
  const org = token ? getOrgAlias(token) : null;
  const version = import.meta.env.VITE_APP_VERSION;
  const footer = [org, version && `v${version}`].filter(Boolean).join(" · ");
  const demo = (key: string) => t(`demoSwitch.${key}`);
  return (
    <span data-tour="user-menu" className="text-base">
      <UserMenu
        name={user?.name || user?.username}
        email={user?.email}
        open={open}
        onOpenChange={setOpen}
        items={[
          { icon: "user", label: t("myAccount"), onClick: accountManagement },
          {
            icon: "presentation",
            label: demo("label"),
            checked: demoMode || autoDemoMode,
            // switching reloads the app; off also opts out of the automatic demo
            onChange: setDemoModeAndReload,
            hint: autoDemoMode && !demoMode ? demo("autoHint") : demo("hint"),
          },
        ]}
        onLogout={logout}
        footer={footer || undefined}
      />
    </span>
  );
}
